<template>

    <div>

        <div :id="'appointment-selector-' + appointmentRecord.id" class="row align-items-center">

            <div class="col-auto">
                <div class="custom-control custom-radio mt-2">
                    <!--@input="updateModel()"-->
                    <input ref="radioElement" type="radio" :name="name" :id="prefixId + appointmentRecord.id" :checked="isChecked()" @change="updateModel()" :value="appointmentRecord.id" class="custom-control-input">
                    <label :for="prefixId + appointmentRecord.id" aria-label="Select this appointment" class="custom-control-label">
                        <span class="d-none">Select This Appointment</span>
                    </label>
                </div>
            </div>

            <div class="col-auto pl-0 mr-3 text-center">
                <div class="row">
                    <div class="col">
                        <p class="h4">{{appointmentRecord.appointmentDate | formatToDayNumber}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        {{appointmentRecord.appointmentDate | formatToMonthAbbr}}
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="row">
                    <div class="col">
                        <span class="appointment-record-subtitle">{{appointmentRecord.externalVisitTypeName}}</span>
                    </div>
                </div>
                <div v-if="appointmentRecord.externalProviderName" class="row">
                    <div class="col">
                        <span class="appointment-record-subtitle">{{appointmentRecord.externalProviderName}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <span class="appointment-record-subtitle">{{appointmentRecord.address1}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <span v-if="appointmentRecord.appointmentTime" class="appointment-record-subtitle">{{appointmentRecord.appointmentTime | formatTimeAddEST}}</span>
                        <span v-else="appointmentRecord.appointmentTime" class="appointment-record-subtitle">TBD: We will notify you when a time is assigned</span>
                    </div>
                </div>
            </div>

        </div>

        <div class="row mobile-full-width-hr">
            <div class="col">
                <hr />
            </div>
        </div>

    </div>

</template>

<script>

    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';

    export default {
        name: 'appointmentRecordTile',
        props: {
            prefixId: { type: String },
            appointmentRecord: { type: Object },
            name: { type: String },
            value: { type: Number },
            cmsContentBlocks: {}
        },
        methods: {

            isChecked: function () {
                //in a computed property it doesn't work when an external source changes is. leave as method
                return this.appointmentRecord.id == this.value;
            },

            updateModel: function () {
                this.$emit('input', this.appointmentRecord.id);
            }

        }
    };
</script>

